import { IBaseResponseData, ICommitteeReport } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of reports from the `/summaries` endpoint.
 */
export interface ICommitteeReportResponse extends IBaseResponseData {
  reports: ICommitteeReport[]
}
